import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import OrdemServico1 from '../imagens/LancOrdemServicos/OrdemServico1.png';
import OrdemServico2 from '../imagens/LancOrdemServicos/OrdemServico2.png';
import OrdemServico3 from '../imagens/LancOrdemServicos/OrdemServico3.png';
import OrdemServico4 from '../imagens/LancOrdemServicos/OrdemServico4.png';
import OrdemServico5 from '../imagens/LancOrdemServicos/OrdemServico5.png';
import OrdemServico6 from '../imagens/LancOrdemServicos/OrdemServico6.png';
import OrdemServico7 from '../imagens/LancOrdemServicos/OrdemServico7.png';


export default class LancOrdemServico extends Component {

  render() {

    const { isOpen, onClose } = this.props;

    return (
      <Modal
        title="Como criar uma Ordem de Serviço"
        className="modal"
        visible={isOpen}
        destroyOnClose
        onCancel={onClose}
        footer={null}
        width="50%"
        style={{ top: 10 }}
      >
        <Row>
          <Col xs={24}>
            <p>
              Primeiramente clique no botão "Adicionar" na tela de ordens de serviço.
            </p>
            <div className="image-wrapper">
              <img src={OrdemServico1} alt="Ordem de serviço 1" />
            </div>

            <div className="gray_bar"></div>

            <p>
              Dentro do cadastro de Ordens de Serviço existem várias abas com informações da OS. Neste guia iremos explicar cada uma delas.
            </p>
            <p>
              Na primeira aba de dados principais, basta preencher todos os campos com as informações necessárias. Aqui você pode também marcar
              caso for necessário emitir notas fiscais dos itens ou dos serviços. O valor da OS é calculado conforme itens e serviços são adicionados.
            </p>
            <div className="image-wrapper">
              <img src={OrdemServico2} alt="Ordem de serviço 2" />
            </div>

            <div className="gray_bar"></div>

            <p>
              A segunda aba de "Itens da OS" serve para que o gestor possa incluir um item do estoque caso ele for usado na OS. Depois, quando o gestor adicionar serviços
              pode ser que alguns itens vinculados ao serviço sejam adicionados a OS. Para adicionar um item basta clicar no botão "+ Novo item" e preencher as informações
              corretamente.
            </p>
            <div className="image-wrapper">
              <img src={OrdemServico3} alt="Ordem de serviço 3" />
            </div>

            <div className="gray_bar"></div>

            <p>
              A terceira aba de "Histórico" possui dois campos descritivos que podem ser usados para anotações e observações sobre a OS.
            </p>
            <div className="image-wrapper">
              <img src={OrdemServico4} alt="Ordem de serviço 4" />
            </div>

            <div className="gray_bar"></div>

            <p>
              A quarta aba de "Check-list" serve para definir quais dos serviços que foram cadastrados no sistema se aplica a OS atual. Se o serviço não se aplica a OS atual,
              basta clicar no botão com o "X" que diz "Não se aplica", e aquele serviço não será atribuído a essa OS. Conforme a OS progride e o serviço é feito ou não,
              o gestor pode usar os botões de conforme e não conforme para marcar os serviços prestados e os que estão faltando.
            </p>
            <p>
              Os checklists podem também ser cadastrados sem vínculo com nenhum produto ou serviço e utilizados apenas como lembretes. Um exemplo é quando uma loja de reparos
              de celular cria checklists para verificar se um cliente deixou algum item junto com o celular, como por exemplo a capinha ou o carregador do celular.
            </p>
            <div className="image-wrapper">
              <img src={OrdemServico7} alt="Ordem de serviço 7" />
            </div>

            <p>
              Um detalhe é que os itens atrelados aos serviços só são adicionados a OS depois que o gestor salvar a nova OS.
            </p>
            <div className="image-wrapper">
              <img src={OrdemServico5} alt="Ordem de serviço 5" />
            </div>

            <div className="gray_bar"></div>

            <p>
              A quarta e última aba da OS é a aba de "Forma de Pagamento". Baseado na forma de pagamento e condição de pagamento que o gestor escolher, o sistema calcula
              parcelas e valores do pagamento. Essa opção deve ser usada após salvar os serviços e itens da OS.
            </p>
            <div className="image-wrapper">
              <img src={OrdemServico6} alt="Ordem de serviço 6" />
            </div>

          </Col>
        </Row>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancOrdemServico.js